import { PALETTE_MAX_HEIGHT, PALETTE_WIDTH } from './UniversalSearch.constants';

export const backdropStyles = {
  zIndex: ({ zIndex }) => zIndex.modal,
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  backdropFilter: 'blur(2px)',
};

export const paletteContainerStyles = {
  position: 'fixed',
  top: '20%',
  left: '50%',
  transform: 'translateX(-50%)',
  width: `${PALETTE_WIDTH}px`,
  maxHeight: `${PALETTE_MAX_HEIGHT}px`,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '12px',
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: '0px 16px 48px rgba(0, 0, 0, 0.16)',
  zIndex: ({ zIndex }) => zIndex.modal + 1,
  overflow: 'hidden',
};

export const searchInputWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '12px 16px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const searchInputStyles = {
  flex: 1,
  border: 'none',
  outline: 'none',
  color: ({ palette }) => palette.text.primary,
  backgroundColor: 'transparent',
  '&::placeholder': {
    color: ({ palette }) => palette.text.placeholder,
  },
};

export const searchIconStyles = {
  color: ({ palette }) => palette.text.placeholder,
  flexShrink: 0,
};

export const escHintStyles = {
  padding: '2px 6px',
  borderRadius: '4px',
  backgroundColor: ({ palette }) => palette.background.hoverDefault,
  color: ({ palette }) => palette.text.secondary,
  lineHeight: '16px',
  flexShrink: 0,
};

export const resultsContainerStyles = {
  flex: 1,
  overflowY: 'auto',
  padding: '8px 0',
};

export const footerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '8px 16px',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.secondary,
};

export const footerHintStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  color: ({ palette }) => palette.text.secondary,
  lineHeight: '16px',
};

export const footerKeyStyles = {
  padding: '1px 5px',
  borderRadius: '3px',
  backgroundColor: ({ palette }) => palette.background.hoverDefault,
  color: ({ palette }) => palette.text.dark,
};

export const noResultsContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '32px 16px',
  gap: '8px',
};

export const noResultsTitleStyles = {
  color: ({ palette }) => palette.text.dark,
};

export const noResultsSuggestionStyles = {
  color: ({ palette }) => palette.text.placeholder,
  textAlign: 'center',
};

export const emptyStateContainerStyles = {
  overflowY: 'auto',
  flex: 1,
  padding: '4px 0',
};

export const recentSectionHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '6px 16px 2px',
};

export const recentClearButtonStyles = {
  color: ({ palette }) => palette.text.placeholder,
  cursor: 'pointer',
  '&:hover': {
    color: ({ palette }) => palette.text.dark,
  },
};

export const emptyStateShortcutsSectionStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '6px',
  padding: '8px 16px 12px',
  borderTop: ({ palette }) => `1px solid ${palette.border.light}`,
  marginTop: '4px',
};

export const emptyStateShortcutRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};

export const emptyStateShortcutKeyStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '32px',
  padding: '2px 6px',
  lineHeight: 1,
  borderRadius: '4px',
  backgroundColor: ({ palette }) => palette.background.disabled,
  color: ({ palette }) => palette.text.dark,
  flexShrink: 0,
};

export const emptyStateShortcutLabelStyles = {
  color: ({ palette }) => palette.text.dark,
};
